import { DiscountType } from "@omni/types/api/product/bff/shared/enums/discountType.enum";

const getAbsoluteAmount = (promoPrice: number, percentage: number) => {
    return Math.round(((promoPrice * percentage) / 100) * 100) / 100;
};

const getPriceAfterCashbackIsApplied = (
    currentPrice: number | null,
    cashback: any | null
) => {
    if (currentPrice && cashback?.cashbackAmount) {
        if (cashback?.cashbackUnit === DiscountType.Absolute) {
            return currentPrice - cashback?.cashbackAmount;
        } else if (cashback?.cashbackUnit === DiscountType.Percentage) {
            const absoluteDiscount = getAbsoluteAmount(
                currentPrice,
                cashback.promotionPercent
            );

            return currentPrice - absoluteDiscount;
        }
    }
    return null;
};

export { getPriceAfterCashbackIsApplied };
